import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { Request } from 'commons/utils/request'

export const ChangesDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/$id/warnings-details',
    component: lazyRouteComponent(() => import('./SARChangesDetails')),
    beforeLoad: ({ params, search, ...all }) => {
      if ('id' in params) return { ...all, flatDeps: { id: Number(params.id), ...search } }
      else throw new NotFoundError()
    },
    loader: async ({ context: { flatDeps } }) => Request.post(Request.urls.bank.sarChangesDetails, { id: flatDeps.id })
  })
